import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Abholung',
        [ORDER_METHODS.DELIVERY]: 'Lieferung',
        [ORDER_METHODS.ON_SITE]: 'Tischbestellung',
      },
    },
    delivery_info: {
      title: 'Abgabe Optionen',
      on_arrival: 'Bei Ankunft:',
    },
    customer_info: {
      title: 'Kontakt',
    },
    payment: {
      title: 'Zahlung',
    },
    request_invoice: {
      title: 'Rechnung anfordern',
      form: {
        is_receipt_required: {
          label: 'Rechnung via Email erhalten',
        },
      },
    },
    location: {
      title: 'Restaurant Adresse',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Lieferadresse',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Dein Tisch',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Abholadresse',
      },
    },
    method: {
      title: 'Methode',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Lieferung',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Tischbestellung',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Abholung',
      },
    },
    time: {
      title: 'Zeit',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standard {{time}} min, Heute',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Planen für später',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Tür klingeln',
        [DropoffAction.Sms]: 'Kontaktiere mich per SMS bei Ankunft',
      },
    },
    doorbell_name: {
      placeholder: 'Türklingelname (optional)',
    },
    company_name: {
      placeholder: 'Firmenname (optional)',
    },
    customer_note: {
      placeholder: 'Noch etwas für das Restaurant?',
    },
  },
  buttons: {
    change: 'Ändern',
    edit: 'Bearbeiten',
    done: 'Fertig',
    add_delivery_note: '+ Lieferdetails hinzufügen',
    add_order_note: '+ Anmerkung zur Bestellung hinzufügen',
  },
  summary: {
    doorbell: 'Türklingel',
    company: 'Firma',
    note: 'Anmerkung zur Bestellung',
  },
};
